import { CSInterface } from "csinterface-ts";
import {jsxConstsEvents} from '../jsxConsts';
import { rootStore } from "../../store/root";

const { csInterface }: { csInterface: CSInterface } = window as any;

export function renderStart(){
  csInterface.addEventListener(jsxConstsEvents.renderStart, (data: any) => {
    const {
      uiStore : {setRenderProgress},
    } = rootStore;
    setRenderProgress(0);
  });
}